/* eslint-disable angular/document-service */
export default class TemplateBuilderService {
  constructor($state, DomService, FEService, FlashService, TemplateService, SchemaService) {
    'ngInject';
    this.$state = $state;
    this.fl = FlashService;
    this.dom = DomService;
    this.fe = FEService;
    this.ts = TemplateService;
    this.ss = SchemaService;

    this.pendingFileData = {};
    this.defaultCss = { zIndex: 0, position: '' };
    this.embeddedConstCss = { 'font-size': '2.8vw', width: '90%', left: '5%' };
  }

  //#region Template Creation functions

  newTemplate(request) {
    return this.fe.httpsCallable('newTemplate', request);
  }

  changeTemplate(request) {
    return this.fe.httpsCallable('changeTemplate', request);
  }

  copyTemplate(request) {
    return this.fe.httpsCallable('copyTemplate', request);
  }
  //#endregion

  //#region Template Removal functions
  deleteTemplate(templateId) {
    return this.fe.httpsCallable('deleteTemplate', { templateId });
  }
  //#endregion

  //#region Validation functions

  getUsedFIDsByRef(tokens, refs) {
    const tables = {};

    refs.forEach(ref => {
      if (ref.uploadFID) tables[ref.id] = [ref.uploadFID];
    });

    tokens.forEach(token => {
      const refId = token.referenceId;
      const fid = token.fieldId;

      if (!tables[refId]) tables[refId] = [];
      tables[refId].push(String(fid));
    });

    return tables;
  }

  getRequiredFIDs() {
    return this.ts.references.reduce((acc, ref) => {
      const schema = this.ss.schemas[ref.tableId];
      if (!schema || !ref.id) return acc;
      acc[ref.id] = Object.values(schema.fields)
        .filter(f => f.isRequired)
        .map(f => `${f.id}`);
      return acc;
    }, {});
  }

  get missingRequired() {
    const { tokens, references } = this.ts;
    const usedFIDsByRef = this.getUsedFIDsByRef(tokens, references, true);
    const requiredFIDsByRef = this.getRequiredFIDs();
    return references.reduce((acc, ref) => {
      const usedFIDs = usedFIDsByRef[ref.id] || [];
      const requiredFIDs = requiredFIDsByRef[ref.id] || [];
      requiredFIDs.forEach(reqFid => {
        if (!usedFIDs.includes(reqFid)) {
          acc[ref.id] = acc[ref.id] || [];
          acc[ref.id].push(reqFid);
        }
      });
      return acc;
    }, {});
  }
  //#endregion

  //#region CSS Scaling functions

  getLayoutText(layout) {
    let cssObj = this.getCssObj(layout);
    return this.getLayoutFromCssObj(cssObj);
  }

  getScrollbarWidth() {
    const outerElm = document.createElement('div');
    $(outerElm).css({ visibility: 'hidden', overflow: 'scroll', msOverflowStyle: 'scrollbar' });
    document.body.appendChild(outerElm);
    const innerElm = document.createElement('div');
    outerElm.appendChild(innerElm);
    const scrollbarWidth = (outerElm.offsetWidth - innerElm.offsetWidth);
    outerElm.parentNode.removeChild(outerElm);
    return scrollbarWidth;
  }

  getCssObj(layout) {
    // Key styles to test when making changes to this logic: font-family, urls
    return layout.trim().split(';').reduce((acc, kv) => {
      const attr =  kv.slice(0, kv.indexOf(':')).trim();
      let value =  kv.slice(kv.indexOf(':') + 1).trim();
      if (!value) return acc;
      if (value.toLowerCase().startsWith('url('))
        [/\\"/g,/"/g,/'/g].forEach(rgx => value = value.replace(rgx, ''));
      else 
        [/\\"/g,/"/g].forEach(rgx => value = value.replace(rgx, "'"));
      acc[attr] = value.trim();
      return acc;
    }, {});
  }

  getLayoutFromCssObj(cssObj) {
    return JSON.stringify(cssObj)
      .slice(2, -2)
      .replace(/","/g, ';')
      .replace(/":"/g, ': ')
      + ';';
  }

  getVwRatio() {
    const templateWidth = ((angular.element(`#builder-container`) || [])[0] || {}).offsetWidth;
    const tbPanelExists = !!angular.element(`#tool-box-panel`).length;
    return (templateWidth && tbPanelExists)
      ? $('body').width() / templateWidth
      : 1.4; //default assuming sm-col-9:sm-col-3 column ratio
  }

  getCompedVwStyle(layout, increase) {
    const vwRatio = this.getVwRatio();
    return layout.replace(/(\d+(\.\d+)?)(?=vw)/g, match => increase
      ? Math.round(1000 * (Number(match) * vwRatio)) / 1000
      : Math.round(1000 * (Number(match) / vwRatio)) / 1000
    );
  }

  getDynamicTokenLayout(pageLayout, token, tokenCssObj) {
    const skipDropStyles = ['dblink'].includes(token.fieldSchema?.fieldType);
    const autoSize = ['radio-control'].includes(token.control.type);
    // Get default token dims when not printing
    if (!skipDropStyles && token.fieldSchema) {
      const pageCss = this.getCssObj(pageLayout);
      const pageWidthValue = parseFloat(pageCss.width || '8.5in');
      const dropWidth = ((parseFloat(token.fieldSchema.dropDimensions.width) / 100) * pageWidthValue).toFixed(3) + 'in';
      //const dropHeight = ((parseFloat(token.fieldSchema.dropDimensions.height) / 100) * pageWidthValue).toFixed(3) + 'in';
      tokenCssObj.width = autoSize ? 'auto' : tokenCssObj.width || dropWidth;
      tokenCssObj.height = tokenCssObj.height || 'fit-content'; // || dropHeight
    }
    return this.getLayoutFromCssObj(tokenCssObj);
  }

  getJqElementsSharedStyles(elements) {
    const cssObjs = elements.toArray().map(e => this.getCssObj(e.attributes['style']?.value || ''));
    if (!cssObjs.length) return '';
    return this.getCssObjSharedStyles(cssObjs);
  }

  getCssObjSharedStyles(objects) {
    return Object.keys(objects[0]).reduce((acc, key) => {
      if (objects.every(obj => obj[key] == objects[0][key])) {
        acc += `${key}: ${objects[0][key]};`;
      }
      return acc;
    }, "");
  }
  //#endregion

  //#region token css operations

  resetCss(token) {
    const relativeOffset = this.dom.getTokenPageOffset(token);
    const css = this.getInitialCss(relativeOffset, token);
    this.dom.getJqToken(token).attr("style", '');
    return this.safeApplyTokenCss(token, css);
  }

  getInitialCss(relativeOffset, token, zoom = 100, pageDims) {
    let { "dropDimensions": { width, height } } = token.fieldSchema;
    if (["multicheckbox-control"].includes(token.control.type)) width = height;
    let lineCount = token.control.lineCount;
    let zHeight = (height.replace('vw', '') / (100 / zoom)) + 'vw';
    let zWidth = (width == height) ? zHeight : width;
    let basicCss = { width: zWidth, height: zHeight };

    if (relativeOffset) {
      const page = this.dom.getPageSize(token.pageId);
      basicCss.left = `${100 * relativeOffset.left / page.width}%`;
      basicCss.top = `${100 * relativeOffset.top / page.height}%`;
      basicCss = { ...basicCss, ...this.defaultCss };
    }
    else {
      basicCss = { ...basicCss, ...this.getDynamicTokenDims(pageDims, basicCss) };
      zHeight = basicCss.height;
    }

    return {
      ...basicCss,
      ...this.getFontSizeCss(zHeight, lineCount, token, true),
      ...token.options?.embedUrlType && this.embeddedConstCss
    };
  }

  getStyleUnits(style, default_ = 'in') {
    return (style.match(/[A-Za-z%]+$/) || [default_])[0];
  }

  getDynamicTokenDims(pageDims, originalCss) {
    // NOTE: only % to inches for now!
    const pageWidth = pageDims.innerWidthValue;
    const pageHeight = pageDims.innerHeightValue;
    const pageWidthUnits = 'in';

    const origHeight = parseFloat(originalCss.height);
    const origHeightPerc = origHeight / 100;
    const origWidthPerc = parseFloat(originalCss.width) / 100;

    const newWidth = (pageWidth * origWidthPerc).toFixed(3);
    const newHeight = (pageHeight * origHeightPerc).toFixed(3);

    let dynCss = {};
    dynCss.width = newWidth + pageWidthUnits;
    dynCss.height = newHeight + pageWidthUnits;

    ['font-size', 'line-height'].forEach(prop => {
      if (originalCss[prop]) {
        const propUnits = this.getStyleUnits(originalCss[prop]);
        if (propUnits != 'in') { // only 'in' for now
          const propValPerc = (parseFloat(originalCss[prop])) / origHeight;
          const newPropVal = (newHeight * propValPerc).toFixed(3);
          dynCss[prop] = newPropVal + 'in';
        }
      }
    });

    if (originalCss.width == originalCss.height) dynCss.width = dynCss.height;

    return dynCss;
  }

  getDynamicPageDims(layout) {
    let pageSize = this.getCssObj(layout);
    let dimensions = {
      width: pageSize.width || '8.5in',
      height: pageSize.height || '11in',
      widthPixels: parseFloat($('.cke_wysiwyg_div').css('width')),
      widthValue: parseFloat(pageSize.width || 8.5),
      heightValue: parseFloat(pageSize.height || 11)
    };

    const baseMargin = pageSize.margin || '0in';
    const margins = {
      base: baseMargin,
      left: (pageSize['margin-left'] || baseMargin),
      right: (pageSize['margin-right'] || baseMargin),
      top: (pageSize['margin-top'] || baseMargin),
      bottom: (pageSize['margin-bottom'] || baseMargin)
    };
    Object.keys(margins).forEach(key => { margins[`${key}Value`] = parseFloat(margins[key] || baseMargin) });
    const innerWidth = dimensions.widthValue - (margins.leftValue + margins.rightValue);
    const innerHeight = dimensions.heightValue - (margins.topValue + margins.bottomValue);

    dimensions = {
      ...dimensions,
      margins,
      innerWidth: innerWidth + 'in',
      innerWidthValue: innerWidth,
      innerHeight: innerHeight + 'in',
      innerHeightValue: innerHeight
    };
    return dimensions;
  }

  getFontSizeCss(heightStyle, lineCount = 1, token, newDrop) {
    if ((lineCount > 1 || token.format === 'image') && !newDrop) return null;
    if (token.options?.embedUrlType) return { 'line-height': heightStyle };

    const height = parseFloat(heightStyle);
    const units = this.getStyleUnits(heightStyle, 'vw');

    const lineHeight = height / lineCount; //for multi line inputs
    const fontSize = (0.75 * lineHeight).toFixed(3);

    return { 'line-height': `${lineHeight}${units}`, 'font-size': `${fontSize}${units}` };
  }

  getResizeCss(token, dims, fSchema) {
    const $token = this.dom.getJqToken(token, false);
    const pxHeight = dims.height || this.getCssObj(token.layout).height;
    const pxWidth = dims.width || this.getCssObj(token.layout).width;
    const pageWidth = this.dom.getPageSize(token.pageId).width;
    const height = this.pxValToVw(pxHeight, pageWidth);
    const width = this.pxValToPct(pxWidth, pageWidth);
    const origHeight = $token.height();
    const heightChanged = (Math.abs(Math.floor(pxHeight) - Math.floor(origHeight)) > 1);

    return {
      height, width,
      ...heightChanged ? this.getFontSizeCss(height, token.control.lineCount, token, false): {},
    };
  }

  pxValToPct(val, max) { // numeric (234) or with units ('5%')
    return typeof val === 'number'
      ? Math.min(100, 100 * val / max) + '%'
      : val;
  }

  pxValToVw(val, containerSize) { // numeric (234) or with units ('5vw')
    const trueVw = typeof val === 'number'
      ? 100 * Math.min(25, val / containerSize)
      : val;
    return parseFloat(trueVw) / this.getVwRatio() + 'vw';
  }

  safeApplyTokenCss(token, newCss) {
    let css = newCss ? { ...newCss } : this.getCssObj(this.getCompedVwStyle(token.layout));
    const exceededBounds = this.dom.getTokenExceededBounds(token, css);
    if (exceededBounds) {
      css = this.bumpTokenOntoPage(token, css, exceededBounds);
      const newExceededBounds = this.dom.getTokenExceededBounds(token, css);
      if (newExceededBounds) return console.error('New layout out of range', css, exceededBounds);
    }

    this.applyCssLayout(token, css);
  }


  applyCssLayout(token, css, isNewToken) { // need $helper when initializing token
    const $token = this.dom.getJqToken(token, isNewToken);
    $token.css(css);
    const style = this.getCompedVwStyle($token.attr("style"), true);
    token.layout = this.getLayoutText(style);
  }


  bumpTokenOntoPage(token, badCss, bounds) {
    const pg = this.dom.getPageSize(token.pageId);
    const $token = this.dom.getJqToken(token);
    const $clone = $token.clone().css(badCss);
    $token.parent().append($clone);
    const dims = this.dom.getJqCssVals($clone, ['height', 'width']);
    $clone.remove();
    return {
      ...badCss,
      ...(bounds.top > 0) && { top: '0%' },
      ...(bounds.left > 0) && { left: '0%' },
      ...(bounds.bottom > 0) && { top: this.pxValToPct(pg.height - dims.height, pg.height) },
      ...(bounds.right > 0) && { left: this.pxValToPct(pg.width - dims.width, pg.width) },
    };
  }

  //#endregion token css operations

  addTemplateFieldLink(templateFieldLink) {
    const useIntegratedAuth = !(this.ts.template.connectionProperties?.includes("usertoken"));
    const request = ({ template: this.ts.toRaw({ includeRefs: true }), templateFieldLink, useIntegratedAuth });
    return this.fe.httpsCallable('addTemplateFieldLink', request);
  }

  addTemplateHook(template, templateHook) {
    const userToken = templateHook.suppliedConnection?.userToken;
    const clearConnection = userToken == null;
    const connection = {
      realm: template.realm,
      ...(userToken && { userToken })
    };
    const request = ({ template, templateHook, connection, clearConnection });
    return this.fe.httpsCallable('addTemplateHook', request);

  }

  publishPage(template) {
    const request = ({ template: { realm: template.realm, appId: template.appId, connectionId: template.connectionId, id: template.id } });
    return this.fe.httpsCallable('publishPage', request);
  }

  getRefUploadFieldConfig(template, reference, PROVIDER, updatable) {
    const { uploadFID, filenameFID, uploadType, tableSchema } = reference;
    const uploadFields = this.getRefUploadFields(template, reference, PROVIDER);
    const filenameFields = this.getRefFilenameFields(reference, PROVIDER);
    const defaultUploadLbl = uploadFields.length ? (updatable ? 'Set Upload Field' : 'NONE') : 'No Upload Fields available';
    const defaultFilenameLbl = filenameFields.length ? (updatable ? 'Set Filename Field' : 'NONE') : 'No Filename Fields available';
    const uploadFieldSchema = tableSchema?.fields?.find(({ id }) => id == uploadFID);
    const filenameFieldSchema = tableSchema?.fields?.find(({ id }) => id == filenameFID);

    const getUploadFieldConfig = (fields, fid, defaultLbl, resolved, okLabel) => {
      if (!fields.length || !fid) return { label: defaultLbl, unset: true, missing: false };
      if (!resolved) return { label: 'MISSING FIELD!', missing: true, unset: false };
      return { label: okLabel(resolved), missing: false, unset: false };
    };

    const type = uploadType || 'pdf';
    const uploadFieldState = getUploadFieldConfig(uploadFields, uploadFID, defaultUploadLbl, uploadFieldSchema, (f) => `${f.label} (.${type})`);
    const filenameFieldState = getUploadFieldConfig(filenameFields, filenameFID, defaultFilenameLbl, filenameFieldSchema, (f) => f.label);

    const uploadField = { ...uploadFieldState, uploadFID };
    const filenameField = { ...filenameFieldState };
    const missing = !!(uploadField.missing || filenameField.missing);
    const hasValidFilenameOnly = !!(filenameFID && filenameFieldSchema);

    let label;
    if (missing) {
      label = 'MISSING FIELD!';
    } else if (uploadFID && uploadFieldSchema) {
      const nameLabel = filenameFieldSchema?.label || template.title;
      label = `${uploadFieldSchema.label} ([${nameLabel}].${type})`;
    } else if (!uploadFID && hasValidFilenameOnly) {
      label = `Download name: [${filenameFieldSchema.label}]`;
    } else {
      label = defaultUploadLbl;
    }
    const unset = !uploadFID;
    return { uploadField, filenameField, label, missing, unset };
  }

  getRefFilenameFields(reference, PROVIDER) {
    const fields = (reference.tableSchema?.fields || []);
    return fields.filter(f => PROVIDER.filenameFields.includes(f.fieldType));
  
  }

  getRedirFields(reference, PROVIDER) {
    const fields = (reference.tableSchema?.fields || []);
    return fields.filter(f => PROVIDER.redirectFields.includes(f.fieldType));
  }

  getSuccessMsgFields(reference, PROVIDER) {
    const fields = (reference.tableSchema?.fields || []);
    return fields.filter(f => PROVIDER.htmlFields.includes(f.fieldType));
  }

  getPasskeyFields(reference, PROVIDER) {
    const fields = (reference.tableSchema?.fields || []);
    return fields.filter(f => PROVIDER.passkeyFields.includes(f.fieldType));
  }

  getRefUploadFields(template, reference, PROVIDER) {
    const fields = (reference.tableSchema?.fields || []);
    const isUploadField = (field) => {
      const hasImageControl = template.tokens.find(t => t.referenceId === reference.id && t.fieldId == field.id && t.format !== 'image');
      return (field.isFile && PROVIDER.allowMultipleAttachments) || (field.isFile && !hasImageControl);
    };
    return fields.filter(f => isUploadField(f));
  }
}
